import { Helmet } from "react-helmet-async";
import React from "react";

// Define the JSON-LD structured data
const schemaData = [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Alo Asian Kitchen",
            "url": "https://aloasiankitchen.org/",
            "logo": "https://aloasiankitchen.org/aak-logo.png",
            "sameAs": [
            "https://www.instagram.com/aloasiankitchen/",
            "https://www.facebook.com/ALOASIANKITCHENLN/",
            "https://www.yelp.com/biz/alo-asian-kitchen-laguna-niguel"
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "Restaurant",
            "name": "Alo Asian Kitchen",
            "image": "https://aloasiankitchen.org/images/store/outside-front-1.jpg",
            "description": "Modern Vietnamese cuisine in Laguna Niguel. View our menu, delivery options, and partyTray services.",
            "url": "https://aloasiankitchen.org/",
            "logo": "https://aloasiankitchen.org/aak-logo.png",
            "address": {
            "@type": "PostalAddress",
            "streetAddress": "28083 Moulton Pkwy Unit C-4",
            "addressLocality": "Laguna Niguel",
            "addressRegion": "CA",
            "postalCode": "92677",
            "addressCountry": "US"
            },
            "telephone": "+1-949-328-9951",
            "servesCuisine": ["Vietnamese"],
            "menu": "https://aloasiankitchen.org/documents/menu.pdf",
            "priceRange": "$$",
            "openingHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                "Monday", "Tuesday", "Thursday", "Friday", "Saturday", "Sunday"
                ],
                "opens": "11:00",
                "closes": "21:00"
            }
            ]
        },
        {
            "@context" : "https://schema.org",
            "@type" : "WebSite",
            "name" : "Alo Asian Kitchen",
            "url" : "https://aloasiankitchen.org/",
            "description": "Official website of Alo Asian Kitchen in Laguna Niguel, offering menu, hours, partyTray, and online contact options.",
            "inLanguage": "en"
        }
    ];

// Component to inject JSON-LD structured data into the document head
const HelmetJsonLd = () => (
    <Helmet>
        <script type="application/ld+json">
            {JSON.stringify(schemaData)}
        </script>
    </Helmet>
);


// React.memo to prevent unnecessary re-renders
export default React.memo(HelmetJsonLd);
